import { Component, OnInit } from '@angular/core';
import { SolicitacaoService } from 'app/service/solicitacao/solicitacao.service';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import * as CryptoJS from 'crypto-js';
import { MatDialog } from '@angular/material/dialog';
import { ControleComponent } from 'app/components/solicitacao/controle/controle.component';
import { ImprimirControleComponent } from 'app/components/solicitacao/imprimir-controle/imprimir-controle.component';
import { AuthenticationService } from '@alfresco/adf-core';


@Component({
  selector: 'app-recuperar-caixas',
  templateUrl: './recuperar-caixas.component.html',
  styleUrls: ['./recuperar-caixas.component.scss']
})
export class RecuperarCaixasComponent implements OnInit {
 result ;
 resultEmRecuperacao;
 loading = false;
 pendenteRecuperacao = [];
 emRecuperacao = [];
 rgInput ;
 horizontalPosition: MatSnackBarHorizontalPosition = 'right';
 verticalPosition: MatSnackBarVerticalPosition = 'top';
 logIsvisivel = false;
 logs = [];
 controles = [];
 adm = false;
  acervo = false;
  solicitacao = true;

  constructor(
    private authService: AuthenticationService,
    private service : SolicitacaoService,
    private _snackBar: MatSnackBar,
    private dialog: MatDialog) { }

  ngOnInit() {
    this.carregarPendenteRecuperacao();
    this.carregarEmRecuperacao();
  }

  addControle() {
    const dialogRef = this.dialog.open(ControleComponent, {
      width: '70%',
      data: {tipoSolicitacao: 'recuperacaoRecipiente'}
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.carregarPendenteRecuperacao();
      console.log(`The dialog was closed - ${result}`);
      console.log(result);
    });
  }

  imprimirControle() {
    const dialogRef = this.dialog.open(ImprimirControleComponent, {
      width: '40%',
      data: {tipoSolicitacao: '0'}
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
    });
  }

  listarControles(idsCaixas) {
    this.service.listarControles(idsCaixas).subscribe(data => {
      console.log(data);
      this.controles = data;
    }, err => {
      console.error(err);
    });
  }

  relatorioCaixasPendentes() {
    if (this.result.result.length === 0 ) {
      this.openSnackBarError('Nenhuma caixa pendente recuperação !');
    } else {
    window.open(`relatorio-caixas-pendente-recuperacao`,
    '_blank',
    'location=yes,height=570,width=520,scrollbars=yes,status=yes'); // Open new window
    }
  }

  alterarVisualizacaoLog(){
    if(this.logIsvisivel){
      this.logIsvisivel = false;
    }else{
      this.logIsvisivel = true;
    }
  }

  carregarPendenteRecuperacao(){
    this.loading = true;
    this.service.listarCaixasPendeteRecuperacao().subscribe(data=>{
      this.result = data;
      console.log(this.result)
      if(this.result.cod == 200){
        this.pendenteRecuperacao = this.result.result;
        this.loading = false;
        let caixasIds = [];
        this.pendenteRecuperacao.map(el => {
          if (el.idControle !== null) {
            caixasIds.push(el.id);
          }
        });
        this.listarControles(caixasIds);
      }
    })
  }

  carregarEmRecuperacao(){
    let user = localStorage.getItem('APS_USERNAME');
    let obj = {"rgCaixa" : "", username: user};
    this.loading = true;
    this.service.caixasEmRecuperacao(obj).subscribe(data=>{
      this.resultEmRecuperacao = data;
      console.log(this.resultEmRecuperacao)
      if(this.resultEmRecuperacao.cod == 200){
        this.emRecuperacao = this.resultEmRecuperacao.result;
        this.loading = false;
      }else {
        this.openSnackBarError(this.resultEmRecuperacao.message)
        this.loading = false;
      }
    })


  }

  rgEmRecuperacao(){
    if(this.rgInput != ""){
      this.incluirRGEmRecuperacao(this.rgInput );
      this.rgInput = "";
    }

  }

  selecionarTodos() {
    console.log(this.pendenteRecuperacao);
    this.pendenteRecuperacao.map(el => {
      console.log(el.id);
      this.incluirRGEmRecuperacao(el.rgCaixa);
    });
  }

  incluirRGEmRecuperacao(rg){
    let user = localStorage.getItem('APS_USERNAME');
    let obj = {"rgCaixa" : rg, username: user};
    this.loading = true;
    console.log(obj);
    this.service.recuperarCaixaUnica(obj).subscribe(data=>{
      this.result = data;
      console.log(this.result)
      if(this.result.cod == 200){
        this.openSnackBarSuccess("Caixa RG "+ rg + " em recuperação !");
        this.logs.push("Caixa RG "+ rg + " em recuperação !");
        this.carregarPendenteRecuperacao();
        this.carregarEmRecuperacao();
      }else if(this.result.cod == 204){
        this.openSnackBarError(this.result.message)
        this.loading = false;
      }
    })

  }

  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ['success-snackbar']
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message,'', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ['error-snackbar']
    });
  }

  recuperarRecipientesUser(){
    let user = localStorage.getItem('APS_USERNAME');
    let obj = {"rgCaixa" : "", username: user};
    this.loading = true;
    this.service.recuperarRecipientesUser(obj).subscribe(data=>{
      this.result = data;
      console.log( this.result)
      if(this.result.cod == 200){
        for(let i = 0 ; i < this.result.result.length; i++){
          this.logs.push("Caixa RG "+ this.result.result[i].rgCaixa + " recuperada !" + ' Controle: ' + this.result.result[i].idControle);
        }
        this.carregarEmRecuperacao();
        this.carregarPendenteRecuperacao();
        this.openSnackBarSuccess("Caixas recuperadas com sucesso!");
      }else {
        this.openSnackBarError(this.result.message)
        this.loading = false;
      }
    })
  }
}



// WEBPACK FOOTER //
// /app/src/app/recuperar-caixas/recuperar-caixas.component.ts